import {
  GET_DEPARTMENT_HISTORY,
  CREATE_DEPARTMENT_HISTORY,
  DELETE_DEPARTMENT_HISTORY,
  GET_LATEST_DEPARTMENT_HISTORY
} from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_DEPARTMENT_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/department_histories",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [CREATE_DEPARTMENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/department_histories/department_history_create";
      const res = await dispatch("apiPost", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [DELETE_DEPARTMENT_HISTORY]({ dispatch }, params) {
      let url = "/kanri/department_histories/" + params.id;
      const res = await dispatch("apiDelete", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [GET_LATEST_DEPARTMENT_HISTORY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/department_histories/get_latest",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
